import React, { ReactNode } from "react";
import { Checkbox, Select } from "antd";
import { AnyObject } from "../../lib/interfaces/AnyObject";

/* Повторяет функционал Select с добавлением возможности "Выбрать все" */

interface IProps {
  allValues: (string | number)[];
  style?: AnyObject;
  onChange?: (value: (string | number)[]) => void;
  placeholder?: string;
  allowClear?: boolean;
  showSearch?: boolean;
  disabled?: boolean;
  showArrow?: boolean;
  loading?: boolean;
  maxTagCount?: number;
  filterOption?: boolean | ((inputValue: string, option: any) => boolean);
  value?: (string | number)[];
  title?: string;
  children: ReactNode;
}

const MultipleSelect = ({
  allValues,
  children,
  style,
  onChange = () => {},
  placeholder,
  allowClear,
  showSearch,
  maxTagCount,
  filterOption,
  disabled,
  showArrow,
  value = [],
  title,
  loading,
}: IProps) => {
  const onSelectAll = (selected: boolean) => {
    onChange && onChange(selected ? allValues : []);
  };
  return (
    <div title={title}>
      <Select
        mode="multiple"
        style={style ? { width: "100%", ...style } : { width: "100%" }}
        dropdownRender={(originNode) => (
          <>
            <Checkbox
              checked={value.length === allValues.length}
              style={{ width: "100%", marginLeft: "10px" }}
              onChange={(e) => onSelectAll(e.target.checked)}
            >
              Выбрать все
            </Checkbox>
            {originNode}
          </>
        )}
        onChange={onChange}
        placeholder={placeholder}
        allowClear={allowClear}
        showSearch={showSearch}
        maxTagCount={maxTagCount}
        filterOption={filterOption}
        disabled={disabled}
        showArrow={showArrow}
        value={value}
        loading={loading}
      >
        {children}
      </Select>
    </div>
  );
};

export default MultipleSelect;
